module.exports = __webpack_public_path__ + "static/img/logo-upgrade.5c7a28eb.svg";